import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import {useState} from 'react';

export default function PollDropdown({object, label, selectedVal, handleDropdownChangeParent}) {
  const [selectedValue, setSelectedValue] = useState(selectedVal || '')
  const handleDropdownChange = (event) => {
    setSelectedValue(event.target.value)
    if (handleDropdownChangeParent) {
      handleDropdownChangeParent(event.target.value)
    }

  }

  return <>
    <FormControl fullWidth size="small">
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        labelId="poll-type-select-label"
        id="demo-simple-select"
        value={selectedValue}
        label={label}
        onChange={handleDropdownChange}
      >
        {Object.entries(object).map(([_, pollTypeValue]) => {
          return <MenuItem value={pollTypeValue}>{pollTypeValue}</MenuItem>
        })}
      </Select>
    </FormControl>
  </>
}
